import BasicResource from '@/api/resource';

class ConfigResource extends BasicResource {
    constructor () {
        super('fraud-protection');
    }

    context = {
        advertiser: 'advertisers',
        offer: 'offers',
        tracking_link: 'tracking-links',
    };

    get (configId, level) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${this.context[level]}/${configId}`,
        });
    }

    update (configId, level, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${this.context[level]}/${configId}`,
            data: data,
        });
    }

    create (level, data) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/${this.resourceName}/${this.context[level]}`,
            data: data,
        });
    }

    default (level, itemId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${this.context[level]}/default/${itemId}`,
        });
    }

    general () {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/general`,
        });
    }

    updateGeneral (data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/general`,
            data: data,
        });
    }

    advertisers (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/advertisers`,
            params,
        });
    }

    offers (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/offers`,
            params,
        });
    }

    trackingLinks (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/tracking-links`,
            params,
        });
    }
}

export default new ConfigResource;

